<div class="content-snackbar">

    <div class="icon">

        <ng-container [ngSwitch]="data.type">

            <ng-container *ngSwitchCase="Types.Info">
                <img  class="icon" src="./assets/img/icons/icon_alert_info.svg" alt="icon" />
            </ng-container>

            <ng-container *ngSwitchCase="Types.Error">
                <img  class="icon" src="./assets/img/icons/icon_alert_error.svg" alt="icon" />
            </ng-container>

            <ng-container *ngSwitchCase="Types.Success">
                <img  class="icon" src="./assets/img/icons/icon_alert_success.svg" alt="icon" />
            </ng-container>

            <ng-container *ngSwitchCase="Types.Warning">
                <img  class="icon" src="./assets/img/icons/icon_alert_warning.svg" alt="icon" />
            </ng-container>

        </ng-container>

    </div>

    <ng-container *ngIf="data.innerHtml; else elseTemplate">

        <div class="content-snack">

            <div class="content-msg">
                {{ data.msg }}
            </div>

            <div class="description" [innerHTML]="data.innerHtml">

            </div>

        </div>

    </ng-container>

    <ng-template #elseTemplate>
        <div class="content-snack">

           <div class="description">
               {{ data.msg }}
           </div>
        </div>
    </ng-template>

    <button *ngIf="data.callback" class="link" (click)="onView()" >
      {{ data.callbackTitle || 'Ver más' }}
    </button>

    <span class="material-icons" (click)="onClose()" *ngIf="data?.innerHtml">
        close
    </span>

</div>
